/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Wrap, WrapItem } from 'chakra-v3';
import { Button, Text } from '../../../../../components/Index';

type ButtonSelectProps<T extends object> = {
  options: T;
  value: keyof T | '';
  onChange: (value: string) => void;
  isDisabled?: boolean;
};
export function ButtonSelect<T extends object>(props: ButtonSelectProps<T>) {
  const handleClick = (value: string) => {
    if (props.value === value) {
      props.onChange('');
    } else {
      props.onChange(value);
    }
  };
  const optionsEntries = Object.entries(props.options);
  if (optionsEntries.length === 0) {
    return (
      <Text variant="body" color="text.primary" opacity={0.8} fontWeight="normal">
        No options available
      </Text>
    );
  }
  return (
    <Wrap gap="10px" justify="flex-start">
      {optionsEntries.map(([value, desc]) => {
        const isSelected = value === props.value;
        return (
          <WrapItem key={value}>
            <Button
              variant={isSelected ? 'secondary' : 'outline'}
              onClick={(e) => {
                e.preventDefault();
                handleClick(value);
              }}
              disabled={props.isDisabled}
            >
              {desc}
            </Button>
          </WrapItem>
        );
      })}
    </Wrap>
  );
}
